import { render, staticRenderFns } from "./add-case-remark.vue?vue&type=template&id=3be45724&scoped=true"
import script from "./add-case-remark.vue?vue&type=script&lang=ts"
export * from "./add-case-remark.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be45724",
  null
  
)

export default component.exports